export const canonicalizeDomain = (value?: string | null) => {
  if (!value) return null;
  try {
    const url = value.includes("://") ? value : `https://${value}`;
    const hostname = new URL(url).hostname.toLowerCase();
    return hostname.startsWith("www.") ? hostname.replace(/^www\./, "") : hostname;
  } catch {
    const cleaned = value
      .replace(/^https?:\/\//i, "")
      .replace(/^www\./i, "")
      .split(/[/?#:]/)[0]
      .split(":")[0]
      .toLowerCase();
    return cleaned || null;
  }
};
